import { session } from '@/utils/storage'

/**
 * Remembers the scroll position of each opted-in list page, so that returning
 * to it (e.g. browser Back after opening a detail page) resumes at the same
 * spot instead of resetting to the top.
 */

const STORAGE_KEY = 'scroll-position-memory'

/** pathname -> scrollTop */
type ScrollPositionMemory = Record<string, number>

const MAX_ENTRIES = 50

let cache: ScrollPositionMemory | null = null

const getMemory = (): ScrollPositionMemory => {
  if (cache === null) cache = session.loadState(STORAGE_KEY) ?? {}
  return cache as ScrollPositionMemory
}

export const rememberScrollPosition = (pathname: string, scrollTop: number) => {
  const memory = getMemory()

  // Re-insert so the key moves to the end: object key order is the eviction
  // order below.
  delete memory[pathname]
  if (scrollTop > 0) memory[pathname] = scrollTop

  const keys = Object.keys(memory)
  for (const key of keys.slice(0, Math.max(0, keys.length - MAX_ENTRIES))) {
    delete memory[key]
  }

  session.saveState(STORAGE_KEY, memory)
}

export const getRememberedScrollPosition = (pathname: string): number =>
  getMemory()[pathname] ?? 0
